import { WorkbenchLayoutStateType } from 'Layouts/Workbench/WorkbenchLayout'
import { useCallback, useMemo } from 'react'

export const useUiState = () => {
    const initialUiState: WorkbenchLayoutStateType = useMemo(() => {
        return JSON.parse(localStorage.getItem('workbench-layout-state') ?? '{}')
    }, [])

    const persistUiState = useCallback((state: Partial<WorkbenchLayoutStateType>) => {
        const currentState = JSON.parse(localStorage.getItem('workbench-layout-state') ?? '{}')
        localStorage.setItem(
            'workbench-layout-state',
            JSON.stringify({ ...currentState, ...state })
        )
    }, [])

    return {
        initialUiState,
        persistUiState,
    }
}
